import styled, { css } from 'styled-components'
import { colors } from 'modules/dashboard/Home/Dashboard.global.styles'
import { phoneMaxWidth, ipadPortraitMaxWidth } from '../../../../DashboardSettings.styles'

export const Wrapper = styled.div`
  max-width: 900px;
  margin: 0 auto;

  @media (max-width: ${ipadPortraitMaxWidth}px) {
    padding: 0 15px;
  };
`

export const TextImageWrapper = styled.div`
  display: flex;
  flex-flow: row;
  padding: 20px 0;
`

export const TextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 400px;
  margin-right: 60px;
`

export const Title = styled.h5`
  font-size: 24px;
  margin: 0;
  color: ${colors.darkPurple};
`

export const List = styled.ul`
  list-style-position: outside;
  padding-left: 15px;
`

export const ListItem = styled.li`
  margin: 10px 0 0;
  color: ${colors.darkPurple};

  :last-of-type {
    margin-bottom: 20px;
  }
`

export const Image = styled.div`
  background-image: url(${ASSETS_PATH}/pages/Dashboard/images/giraffe-teacher.jpg);
  background-size: contain;
  background-repeat: no-repeat;
  min-width: 400px;

  @media (max-width: ${ipadPortraitMaxWidth}px) {
    min-width: 250px;
    margin-left: 30px;
  };
`

export const Paragraph = styled.p`
  color: ${colors.blue};
  margin: 0;
  font-size: 14px;
`
